<template>
  <modal
    :title="$t('integration.export_data')"
    :visible.sync="isShowDialog"
    width="600px"
  >
    <el-form :model="exportForm" label-width="150px" ref="form">
      <el-form-item :label="$t('integration.export_format')" prop="format">
        <el-select
          style="width:250px"
          v-model="exportForm.format"
          :placeholder="$t('integration.please_select_the_export_format')"
        >
          <el-option
            v-for="item in formatArray"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('integration.electronic_signature_')"
        prop="sign"
      >
        <el-radio-group v-model="exportForm.sign" @change="changeFn">
          <el-radio label="0">{{ $t('integration.no') }}</el-radio>
          <el-radio label="1">{{ $t('integration.use_existing') }}</el-radio>
          <el-radio label="2"
            >{{ $t('integration.use_new_signature') }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="exportFn"
        >{{ $t('integration.export') }}
      </el-button>
      <el-button type="primary" @click="isShowDialog = false"
        >{{ $t('buttonTitle.Close') }}
      </el-button>
    </div>
  </modal>
</template>

<script>
import { shareParam, shareSignature } from '@/api/modules/public.js'
import { signature } from '@/utils/winDetail'
import { getExportLanguage, getLanguage } from '@/lang'

export default {
  props: ['isShow', 'searchForm', 'comNmae'],
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val)
      }
    }
  },
  data () {
    return {
      exportForm: {
        format: 1,
        sign: '0',
        pictureBase64: '',
        isCoverage: 0,
        recordId: null,
        lang: getExportLanguage()
      },
      formatArray: [
        {
          value: 1,
          label: 'Pdf'
        }
      ],
      queryObj: {}
    }
  },
  mounted () {
    shareParam({
      code: 'export_type',
      type: 0
    }).then(({ result }) => {
      this.formatArray = result.map(item => ({
        value: parseInt(item.code),
        label: item.name
      }))
    })
  },
  methods: {
    initForm () {
      this.exportForm = {
        format: 1,
        sign: '0',
        pictureBase64: '',
        isCoverage: 0,
        recordId: null,
        lang: getLanguage()
      }
    },
    changeFn (num) {
      this.exportForm.pictureBase64 = ''
      if (num === '1') {
        // 1. 请求接口判断是否存在签名 存在则使用
        // 2. 不存在则进行提示 且选择使用新签名 并且弹出win窗
        shareSignature().then(({ result }) => {
          if (!result || !result.signature) {
            this.$message.warning(
              $t(
                'integration.the_customer_of_the_account_does_not_need_to_sign_c__please_fill_in_a_new_signature'
              )
            )
            this.exportForm.sign = '2'
            signature((win, base64) => {
              this.exportForm.pictureBase64 = base64
              this.exportFn()
              win.close()
            })
          } else {
            this.exportForm.pictureBase64 = result.signature
          }
        })
      } else if (num === '2') {
        // 1. 弹出win窗体
        signature((win, base64) => {
          this.exportForm.pictureBase64 = base64
          this.exportFn()
          win.close()
        })
      }
    },
    exportFn () {
      // let httpUrl = exportData;
      // if (this.comNmae) {
      //     httpUrl = exportDatas
      // }
      // console.log(this.comNmae);
      // return
      this.exportForm = Object.assign(this.exportForm, this.searchForm)

      this.comNmae(this.exportForm).then(({ result, state }) => {
        if (result && state.code === 200) {
          // this.$message.success(new Date().getTime() + '_文件生成中,请到下载页面查看');
          this.isShowDialog = false
          // 如果为真 则需要再请求一次并且戴上记录id并且进行提示
          if (result.isExist) {
            this.$confirm(
              this.$t(
                $t(
                  'integration.this_file_already_exists_dot__do_you_want_to_overwrite_it_q'
                )
              ),
              this.$t($t('integration.tips')),
              {}
            )
              .then(() => {
                this.exportForm.recordId = result.recordId
                this.exportForm.isCoverage = 1
                this.exportFn()
              })
              .catch(() => {})
          } else {
            const fileName = result.fileName
            this.$notify.info({
              title: $t('integration.news'),
              message: `[${fileName}${this.$t('public.Exporting')},${this.$t('public.go_download_page_view')}]`
            })
            // this.$message.success(`导出${result.fileName}成功,请到下载页面查看`)
            this.$store.state.downLoad.listids.push(result.recordId)
            // downloadProgress([result.recordId]).then((res) => {
            //     if (res.result[0].end) {
            //         this.$notify({
            //             title: $t('integration.success'),
            //             message: `${res.result[0].downloadRecord.name}生成成功，请到下载页面下载`,
            //             type: 'success'
            //         });
            //     } else {
            //         // 存储
            //         this.$store.state.downLoad.listids.push(result.recordId)
            //     }
            // })
          }
        } else {
          this.$message.error(state.mag)
        }
      })
    }
  }
}
</script>

<style></style>
